import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export const TagButton = ({ label, selected, onToggle, testId, custom = false }) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={selected}
      data-testid={testId}
      className={cn(
        "group relative flex items-center justify-start gap-2 rounded-xl px-3 py-3 min-h-[3.75rem]",
        "text-left text-sm font-medium transition-all duration-200 ease-in-out",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
        "active:scale-[0.98]",
        selected
          ? "bg-blue-50 border border-blue-500 text-blue-700 shadow-sm ring-1 ring-blue-500"
          : "bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 hover:border-slate-300",
        custom && !selected && "border-dashed border-blue-200 bg-blue-50/30"
      )}
    >
      <span
        className={cn(
          "flex h-5 w-5 shrink-0 items-center justify-center rounded-md border transition-colors",
          selected
            ? "bg-blue-500 border-blue-500 text-white"
            : "bg-white border-slate-300 text-transparent group-hover:border-slate-400"
        )}
        aria-hidden="true"
      >
        <Check className="h-3.5 w-3.5" strokeWidth={3} />
      </span>
      <span className="leading-snug">{label}</span>
    </button>
  );
};

export default TagButton;
